import { useTranslation } from 'react-i18next';
import { HiDatabase as DatabaseIcon } from 'react-icons/hi';
import { HiMiniViewColumns as FieldIcon } from 'react-icons/hi2';
import { Chip, Tabs } from '@knack/asterisk-react';

import { useDataTableStore } from '@/components/data-table/useDataTableStore';

export function RecordsFieldsTabs() {
  const [t] = useTranslation();

  const totalRecords = useDataTableStore().use.totalRecords();

  const items = [
    {
      children: (
        <span className="flex gap-1">
          <DatabaseIcon size={20} className="flex-shrink-0 fill-[url(#svg-gradient-1)]" />
          {t('components.data_table.header.records')}
          <Chip
            text={`${totalRecords}`}
            size="sm"
            className="pointer-events-none m-0 bg-brand-50 py-0"
          />
        </span>
      ),
      value: 'records'
    },
    {
      children: (
        <span className="flex gap-1">
          <FieldIcon size={20} className="flex-shrink-0" />
          <span>{t('keywords.fields_coming_soon')}</span>
        </span>
      ),
      value: 'fields',
      isDisabled: true
    }
  ];

  return (
    <Tabs defaultValue="records">
      <Tabs.List items={items} />
    </Tabs>
  );
}
